module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "part",
    attrs: {
      "id": "part2"
    }
  }, [_c('h1', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/007toc#part2"
    }
  }, [_vm._v("RETRO HOMESPUN")])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    attrs: {
      "id": "image4"
    }
  }, [_c('p', {
    staticClass: "center image_vert"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('img', {
    attrs: {
      "alt": "retro homespun style",
      "height": "80%",
      "src": "images/image-21.jpg",
      "width": "auto"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("SWEET, RUSTIC, CHARMING, AND HANDMADE, retro homespun details are all about nostalgia for the crafts and comfort of a bygone era. Whether it be quilting, knitting, or embroidery, these techniques and textures instantly bring a cozy, heirloom quality to a modern wedding.")]), _vm._v(" "), _c('h2', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("RETRO HOMESPUN STYLE")]), _vm._v(" "), _c('h3', {
    staticClass: "left"
  }, [_vm._v("PALETTES")]), _vm._v(" "), _c('div', {
    staticClass: "table",
    attrs: {
      "id": "table2"
    }
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "cherry",
      "src": "images/image-22a.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Cherry")])]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "tangerine",
      "src": "images/image-22b.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Tangerine")])]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "butter yellow",
      "src": "images/image-22c.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Butter yellow")])]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "coral",
      "src": "images/image-22d.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Coral")])]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "blue",
      "src": "images/image-22e.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Bluebell")])])])])]), _vm._v(" "), _c('h3', {
    staticClass: "left"
  }, [_vm._v("INSPIRATION")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cath Kidston, Liberty of London, vintage fabrics and wallpapers")]), _vm._v(" "), _c('h3', {
    staticClass: "left"
  }, [_vm._v("FONTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("P22 Declaration Script, Nelly Script, Emily Austin, Rosewood Fill, Filosofia Neutra Book, Bryant Regular")]), _vm._v(" "), _c('h3', {
    staticClass: "left"
  }, [_vm._v("TEXTURES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cotton fabric, stitching, embroidery, cross-stitch, buttons, gingham, polka dots, vintage florals, quilting, clothespins, twill tape, etched glass, enameled aluminum, eyelet lace, stripes, plaids")]), _vm._v(" "), _c('h3', {
    staticClass: "left"
  }, [_vm._v("VENUES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Backyard, ranch, barn, farm, winery, historic home, rustic hotel")]), _vm._v(" "), _c('h3', {
    staticClass: "left"
  }, [_vm._v("DETAILS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Make your getaway in a vintage car or on a tandem bicycle * Serve traditional comfort food family style—spaghetti and meatballs, mac and cheese, pork chops, apple sauce, and mashed potatoes * For appetizers or parting treats, serve nostalgic favorites like lemonade, cracker jacks, doughnut holes, or milk and cookies * Hang seating cards using clothespins attached to string or pretty ribbon * Create your own photo booth, with retro fabric as a backdrop * Hand out parasols for a sunny-day wedding")]), _vm._v(" "), _c('h2', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("PUTTING IT ALL TOGETHER")]), _vm._v(" "), _c('ol', {
    staticClass: "decimal"
  }, [_c('li', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("WILDFLOWERS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Choose wildflowers such as lilacs and sweet peas (spring), Queen Anne’s lace and daisies (summer), sunflowers and zinnias (fall), and jasmine and forget-me-nots (winter).")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("MASON JARS, MILK GLASS, AND TEA TINS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("These are perfect vessels for flowers, and can also be filled with dried beans or pebbles to hold votive candles.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("MIX-AND-MATCH PLATES OR NAPKINS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Collect vintage plates from flea markets, eBay, and Goodwill. Or, rent simple white plates and sew mix-and-match patterned napkins.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("VINTAGE HANKIES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Hand these out to guests to dry their eyes during the ceremony.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("HOMEMADE PIES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Serve an assortment of pies instead of cake (a small cutting cake can used for a photo opportunity). Make pie flags noting the different flavors out of patterned paper and a toothpick.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-153eec3d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/015part2.vue
// module id = 93
// module chunks = 0